

export const mergeArraysWithoutDuplicates = (a, b, predicate = (a, b) => a === b) => {
    const c = [...a];
    b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)))
    return c;
}

export const getArrayFromMap = (items) => {
    try {
        return Array.from(items, ([name, value]) => ({...value}));
    } catch (e) {
        return [];
    }
}